module.exports = __webpack_public_path__ + "img/bg-banner.805d996.jpg";